module.exports = __webpack_public_path__ + "static/media/team-0.d83ce6cc.png";